// Ticket.ts
// Represents a work item (ticket) from Azure DevOps

import * as tConst  from "../Common/Constants"; // Adjust the path as needed

export const AF_AREA_PATH = "System.AreaPath";
export const AF_ASSIGNED_TO = "System.AssignedTo";
export const AF_CAPEX = "Custom.CapEx"; // Assuming this is the field for Capex
export const AF_CREATED = "System.CreatedDate";
export const AF_END_ITERATION = "Custom.EndIteration";
export const AF_GOV_PROJECT = "Custom.GovProject"; // Assuming this is the field for government project
export const AF_GUESTIMATE = "Custom.Guestimate";
export const AF_ID = "id";
export const AF_INITIATIV = "Custom.Initiative";
export const AF_JIRA_LINK = "Custom.JiraIssueKey";
export const AF_PARENT = "System.Parent";
export const AF_PLANNING_PRIORITY = "Custom.Planningpriority";
export const AF_PLANNING_STATUS = "Custom.PlanningStatus";
export const AF_PRIORITY_DRIVER = "Custom.PriorityDriver"; // Assuming this is the field for priority driver
export const AF_PROJECT = "System.TeamProject"
export const AF_REL = "rel";
export const AF_REL_PARENT = "System.LinkTypes.Hierarchy-Reverse";
export const AF_REL_CHILD = "System.LinkTypes.Hierarchy-Forward";
export const AF_REL_PREDECESSOR = "System.LinkTypes.Dependency-Reverse";
export const AF_REL_SUCCESSOR = "System.LinkTypes.Dependency-Forward";
export const AF_RELATION = "relations";
export const AF_REPORTER = "System.CreatedBy"
export const AF_START_ITERATION = "Custom.StartIteration";
export const AF_STATE = "System.State"
export const AF_TAGS = "System.Tags";
export const AF_TEAMS = "Custom.Teams";
export const AF_TITLE = "System.Title";
export const AF_TYPE = "System.WorkItemType";
export const AF_UPDATED = "System.ChangedDate";
export const AF_WORKITEM_TYPE = "System.WorkItemType";
export const AF_DEMO = "Custom.Demo";
export const AF_PRODUCT = "Custom.SensioProduct";
export const AF_INVESTMENT_CLASS = "Custom.Investmentclass";



export class Ticket {
  id: number;
  title: string;
  state: string;
  endIteration?: Date;
  startIteration?: Date;
  url: string;
  project : string; 
  planningPri: number;
  assignee : string;
  assigneeUniqueName : string;
  length : number = -1;
  planningStatus : string = "";
  initiative : string = "";
  type : string;
  created : Date;
  updated : Date;
  parent : number;
  teamNames: string;
  teamList : string[] = [];
  tags: string;
  tagList: string[] = [];
  priorityDriver: string; // New field for priority driver
  govProject: string; // Assuming this is the field for government project
  capex: string; // Assuming this is the field for Capex
  demo: string; // Demo field
  product: string; // Product field
  investmentClass: string; // Investment Class field
  description: string; // Description/comment field

[key: string]: any; // For any additional fields

  constructor(data: any, GroupTitle = "", Color = "", AdditionalPlanningPriority = 0) {
    this.id = data.id;
    this.title = data.fields?.[AF_TITLE] || data.title || "";
    
    this.color = Color !== "" ? Color : "";
    this.assignee = data.fields?.[AF_ASSIGNED_TO]?.displayName || data.Assignee || tConst.ADO_UNASSIGNED;
    this.assigneeUniqueName = data.fields?.[AF_ASSIGNED_TO]?.uniqueName || data.assigneeUniqueName || "";
    this.type = data.fields?.[AF_WORKITEM_TYPE] ?? "<unknown type>";
    this.project = data.fields?.[AF_PROJECT] || data.Project || "";
    this.state = data.fields?.[AF_STATE] || data.state || "";
    
    this.url = data.url;
    this.groupBy =  GroupTitle !== "" ? GroupTitle : ""; 
    
    this.created = data.fields?.[AF_CREATED] ? new Date(data.fields[AF_CREATED]) : new Date(0);
    this.updated = data.fields?.[AF_UPDATED] ? new Date(data.fields[AF_UPDATED]) : new Date(0);
    
    
    this.area = data.fields?.[AF_AREA_PATH] || data.area || "";
    const _parentUrl = data.relations?.find((rel: any) => rel.rel === AF_REL_PARENT)?.url ;
    this.parent = _parentUrl?.split('/').pop() ? parseInt(_parentUrl.split('/').pop(), 10) : 0; // Extract ID from URL or set to 0 if not found
    this.childrenIds = data.relations?.filter((rel: any) => rel.rel === AF_REL_CHILD).map((rel: any) => {
      return rel.url.split('/').pop() ? parseInt(rel.url.split('/').pop(), 10) : 0; // Extract ID from URL or set to 0 if not found
    }) || []; 

    const _pp = Number(data.fields?.[AF_PLANNING_PRIORITY]);
    this.planningPri = (isNaN(_pp) ? 99999 : _pp) + AdditionalPlanningPriority;
    
    
    
    
    //Todo Verify that this is actually working
    this.initiative = data.fields?.[AF_INITIATIV] || data.initiative || "..";
    this.guestimate = data.fields?.[AF_GUESTIMATE] || data.guestimate || "";
    this.planningStatus = data.fields?.[AF_PLANNING_STATUS] || data.planningStatus || "";
    
    this.teamNames = data.fields?.[AF_TEAMS] ||  ""; 
    this.teamList = this.teamNames 
      ? this.teamNames.split(";").map((team: string) => team.trim()).filter((team: string) => team !== "") 
      : [];

    this.tags = data.fields?.[AF_TAGS] || "";
    this.tagList = this.tags
      ? this.tags.split(";").map((tag: string) => tag.trim()).filter((tag: string) => tag !== "")
      : [];

    this.priorityDriver = data.fields?.[AF_PRIORITY_DRIVER] || data.priorityDriver || "";// Assigning the priority driver field

    this.govProject = data.fields?.[AF_GOV_PROJECT] || data.govProject || ""; // Assuming this is the field for government project
    this.capex = data.fields?.[AF_CAPEX] || data.capex || "";
    this.demo = data.fields?.[AF_DEMO] || data.demo || "";
    this.product = data.fields?.[AF_PRODUCT] || data.product || "";
    this.investmentClass = data.fields?.[AF_INVESTMENT_CLASS] || data.investmentClass || "";
    this.description = "";
    
    // const _end : String = data.fields?.[AF_END_ITERATION];
    // const _start: String = data.fields?.[AF_START_ITERATION];
    
    // console.log("start/end:" + _start+"/"+_end);
    
    try  {
      if (data.fields?.[AF_START_ITERATION]){
        this.startIteration = new Date(data.fields?.[AF_START_ITERATION]);
      }        
      if (data.fields?.[AF_END_ITERATION]) {
        this.endIteration = new Date(data.fields?.[AF_END_ITERATION]);
      }

      
      
      
      if (this.startIteration && this.endIteration) {
        let _length = -1;
        const startStr = data.fields?.[AF_START_ITERATION];
        const endStr = data.fields?.[AF_END_ITERATION];
        
        if (startStr && endStr) {
          const start = new Date(startStr);
          const end = new Date(endStr);
          if (!isNaN(start.getTime()) && !isNaN(end.getTime()) && end > start) {
            const diffMs = end.getTime() - start.getTime();
            const diffDays = diffMs / (1000 * 60 * 60 * 24);
            // Assuming a sprint is 14 days
            _length = Math.ceil(diffDays / 14);
          }
        }
        this.length = _length;
      }
    } catch (error) {
      // deliberately ignore errors in processing ticket data
      console.error("Error processing ticket data:", error);  
    }
    try {
        // Assign any other fields dynamically
        Object.assign(this, data);
      
    } catch (error) {
      // deliberately ignore errors in processing ticket data
        console.error("Error processing ticket data: Object.assign(this, data);", error);
      
    }
  }
}
